import { RefObject } from 'react';
import type { CameraCaptureAttachment } from './index';

export const NativeCameraCapture = (props: {
  inputRef: RefObject<HTMLInputElement | null>;
  onCapture?: (attachment: CameraCaptureAttachment) => void;
  accept?: string;
}) => {
  const handleCapture = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    Array.from(files).forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const data = reader.result as string;
        props.onCapture?.({
          data,
          mimeType: file.type,
          name: file.name,
        });
      };
      reader.readAsDataURL(file);
    });

    event.target.value = '';
  };
  return (
    <input
      ref={props.inputRef}
      type="file"
      accept={props.accept ?? '*/*'}
      multiple
      onChange={handleCapture}
      style={{ display: 'none' }}
    />
  );
};

export const supportsNativeCameraUI = () => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};
